var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthImgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 200,
    viewBox: "0 0 185 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185 40.5C185 128.589 113.589 200 25.5 200C-62.5894 200 -134 128.589 -134 40.5C-134 -47.5894 -62.5894 -119 25.5 -119C113.589 -119 185 -47.5894 185 40.5ZM-75.3664 40.5C-75.3664 96.207 -30.207 141.366 25.5 141.366C81.207 141.366 126.366 96.207 126.366 40.5C126.366 -15.207 81.207 -60.3664 25.5 -60.3664C-30.207 -60.3664 -75.3664 -15.207 -75.3664 40.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthImgLeft);
export default __webpack_public_path__ + "static/media/auth-img-left.68d81f9118551d98048a561dcd3ca6fc.svg";
export { ForwardRef as ReactComponent };